// client/src/utils.js v3
export const fmtCurrency = (v, showZero = false) => {
  if (v === null || v === undefined || v === '') return showZero ? '£0.00' : '—';
  const n = Number(v);
  if (isNaN(n) || (!showZero && n === 0)) return showZero ? '£0.00' : '—';
  return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
};

export const fmtDate = (d) => {
  if (!d) return '—';
  const p = new Date(d);
  return isNaN(p.getTime()) ? d : p.toLocaleDateString('en-GB');
};

export const toInputDate = (d) => {
  if (!d) return '';
  return d.slice(0, 10);
};

export const isOverdue = (t) =>
  t.status === 'Bidding' && t.deadline && t.deadline < new Date().toISOString().slice(0, 10);

export const isDueThisWeek = (t) => {
  if (!t.deadline || t.status !== 'Bidding') return false;
  const today = new Date();
  const due = new Date(t.deadline);
  const diff = (due - today) / 86400000;
  return diff >= 0 && diff <= 7;
};

export const STATUS_OPTIONS = ['Awaiting Decision','Bidding','Submitted-Awaiting','Won','Lost','Paused','Dead','Revision Required'];

export const STATUS_META = {
  'Awaiting Decision':  { color: '#d97706', bg: '#fef3c7', text: '#78350f' },
  'Bidding':            { color: '#3b82f6', bg: '#dbeafe', text: '#1e3a5f' },
  'Submitted-Awaiting': { color: '#f59e0b', bg: '#fef3c7', text: '#78350f' },
  'Won':                { color: '#10b981', bg: '#d1fae5', text: '#065f46' },
  'Lost':               { color: '#ef4444', bg: '#fee2e2', text: '#7f1d1d' },
  'Paused':             { color: '#8b5cf6', bg: '#ede9fe', text: '#4c1d95' },
  'Dead':               { color: '#6b7280', bg: '#f3f4f6', text: '#374151' },
  'Revision Required':  { color: '#f97316', bg: '#fff7ed', text: '#7c2d12' },
};

export const ESTIMATOR_COLORS = ['#60a5fa','#34d399','#fbbf24','#f87171','#a78bfa','#22d3ee'];

export const TIME_FILTERS = [
  { label: '1M', value: '1' },
  { label: '3M', value: '3' },
  { label: '6M', value: '6' },
  { label: '12M', value: '12' },
  { label: 'All', value: 'all' },
];

// Consultancy / Framework / Maintenance / Surveying projects do not use IDNO.
// SUR Phase 1 + REQ-10.
export const isConstructionType = (classificationName) => {
  if (!classificationName) return true; // allow IDNO if unclassified
  const name = classificationName.toLowerCase();
  return !name.includes('consultancy')
      && !name.includes('framework')
      && !name.includes('maintenance')
      && !name.includes('surveying');
};

// REQ-10 + SUR Phase 1: site-address requirement by classification.
// Required for construction AND surveying; optional for consultancy /
// framework / maintenance (they aren't physical-site-first types).
export const requiresAddress = (classificationName) => {
  if (!classificationName) return true;
  const name = classificationName.toLowerCase();
  if (name.includes('surveying')) return true;
  if (name.includes('consultancy') || name.includes('framework') || name.includes('maintenance')) return false;
  return true; // construction default
};

// W3W required only for construction; every other type is exempt.
// (SUR Phase 1: address required, W3W optional for surveying.)
// (REQ-10: framework / maintenance / consultancy all W3W-exempt.)
export const requiresW3W = (classificationName) => {
  if (!classificationName) return true;
  const name = classificationName.toLowerCase();
  if (name.includes('consultancy') || name.includes('framework') || name.includes('maintenance')) return false;
  if (name.includes('surveying')) return false;
  return true;
};
